/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Fc_Wins_6Inputs */

const en_fc_vs_fc_wins_6 = /** @type {(inputs: Fc_Vs_Fc_Wins_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wide interchange: FCPXML, OpenTimelineIO, EDL, AAF and OMF.`)
};

/**
* | output |
* | --- |
* | "Wide interchange: FCPXML, OpenTimelineIO, EDL, AAF and OMF." |
*
* @param {Fc_Vs_Fc_Wins_6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_fc_wins_6 = /** @type {((inputs?: Fc_Vs_Fc_Wins_6Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Fc_Wins_6Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_fc_wins_6(inputs)
});
export { fc_vs_fc_wins_6 as "fc.vs.fc_wins.6" }